"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.hasOccurredMessages = exports.HasOccurred = void 0;
const schema_1 = require("../../../../../schema");
var HasOccurred;
(function (HasOccurred) {
    HasOccurred["OCCURRED"] = "OCCURRED";
    HasOccurred["NOT_OCCURRED"] = "NOT_OCCURRED";
})(HasOccurred || (exports.HasOccurred = HasOccurred = {}));
exports.hasOccurredMessages = {
    [HasOccurred.OCCURRED]: {
        id: "ltx.phaseI.medicalHistory.liverRelatedComplications.hepatorenalSyndrome.hasOccurred.OCCURRED",
        defaultMessage: "Igen"
    },
    [HasOccurred.NOT_OCCURRED]: {
        id: "ltx.phaseI.medicalHistory.liverRelatedComplications.hepatorenalSyndrome.hasOccurred.NOT_OCCURRED",
        defaultMessage: "Nem"
    }
};
const hasOccurred = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HasOccurred.OCCURRED),
    schema_1.Schema.singleChoiceItem(HasOccurred.NOT_OCCURRED)
]).interpretation({ vocab: "ltx", code: "hepatorenal_syndrome" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ hasOccurred });
